import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ChargingKiosk from './components/ChargingKiosk';
import { useGetChargeStation, useGetConnector } from 'queries/charge_station.query';
import { Helmet } from 'react-helmet-async';

export default function ChargeStationView() {
  let { charge_station_id } = useParams();

  const { mutateAsync: ChargeStationMutate, data: chargeStationData, isPending, isSuccess } = useGetChargeStation();
  const { data: connectorData, refetch: refetchConnector } = useGetConnector(charge_station_id);

  const getChargeStationData = useCallback(
    async (charge_station_id: string) => {
      await ChargeStationMutate(charge_station_id);
    },
    [ChargeStationMutate]
  );

  useEffect(() => {
    if (!charge_station_id) return;
    getChargeStationData(charge_station_id);
    const intervalId = window.setInterval(() => {
      getChargeStationData(charge_station_id);
    }, 30000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [charge_station_id, getChargeStationData]);

  useEffect(() => {
    if (!charge_station_id) return;
    const intervalId = window.setInterval(() => {
      refetchConnector();
    }, 10000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [charge_station_id, refetchConnector]);

  return (
    <>
      <Helmet>
        <title>Trạm sạc</title>
      </Helmet>
      <div className="kiosk-wrap">
        <ChargingKiosk station={chargeStationData} connectors={connectorData} />
      </div>
    </>
  );
}

